import { writable } from 'svelte/store';
import collect from 'collect.js';
// Models
import BetAdjustment from '@/Models/BetAdjustment.js';

/**
 * Our Store can be used 2 ways in svelte components
 * 1) ($ prefix) $StoreName to reference writable store collection with all collect.js methods available
 * 2) (Direct) StoreName.method() to call a method on the store
 */
const init = () => {
	const { subscribe, set, update } = writable(collect());

	const methods = {
		getAdjustmentsForBet(betId) {
			const bet = new BetAdjustment();
			bet.resourceUrl = () => {
				return `${bet.baseUrl()}/bets/${betId}/adjustments`;
			};

			return bet.get().then((results) => {
				set(results.data);
				return results;
			});
		},

		betAdjustment(betId, data) {
			const bet = new BetAdjustment();
			bet.resourceUrl = () => {
				return `${bet.baseUrl()}/bets/${betId}/adjust_result`;
			};

			return bet.adjustment(data).then((results) => {
				return results;
			});
		},

		reset() {
			set(collect());
		}
	};

	return {
		subscribe,
		update,
		set,
		...methods
	};
};

export default init();
